module.exports = __webpack_public_path__ + "img/img0.37b86c01.png";